<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" size="lg-fix-h" :ariaLabel="$t('dashboard.connected_users_label') + ' ' + clientError">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('dashboard.connected_users_label')}} {{clientError}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="vld-parent" style="min-height: 350px">
      <loading 
        :opacity="darkMode ? 0 : 0.5" 
        :background-color="darkMode ? 'var(--darkblue-DEFAULT)' : 'white'" 
        color="var(--primary-DEFAULT)" 
        :active="!isLoadedData" 
        :is-full-page="false" 
        :z-index="100000">
        </loading>
      <connected-users-table 
        ref="connectedUsersTable"
        class="m-2" 
        :tableData="dataTable"
        :total="totalData"
        :currentPage="currentPage"
        :perPage="perPage"
        :ascendingOrder="ascendingOrder"
        @changeCurrentPage="changeCurrentPage"
        @changeAscendingOrder="changeAscendingOrder" />
      </div>
    </template>
    <template slot="footer">
      <div class="w-full items-end justify-end flex space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button-responsive mode="secondary-phantom-blue" :text="$t('app.export_excel')" icon='excelxls' @click='exportExcel'
          v-if="false"
          :loading='!isLoadedData || !isLoadedExcel' 
          :disabled="!isLoadedData || !isLoadedExcel" />
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.close')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from '../base/BaseDialogButton.vue'
import ConnectedUsersTable from '@/components/charts/ConnectedUsersTable.vue'
import Loading from 'vue-loading-overlay'
import { getConnectedUsers } from '@/services/dashboard/getConnectedUsers'
// import { getConnectedUsersExcel } from '@/services/errors/getConnectedUsersExcel'
import moment from 'moment'

export default
{
  name: 'connected-users-dialog',
  components: {
    BaseDialogButton,
    ConnectedUsersTable,
    Loading,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.getData()
      } else {
        this.cleanData()
      }
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      isLoadedExcel: true,
      dataTable: [],
      totalData: 0,
      currentPage: 1,
      totalPage: 0,
      perPage: 100,
      ascendingOrder: false,
    }
  },
  
  mounted: async function () {
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isSA: function () {
      return (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador')
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    selectedClientNameDashboard () {
      return this.$store.getters['dashboard/getSelectedClientName']
    },
    clientError () {
      if (this.isSelectedClientDashboard) {
        return this.$t('dashboard.connected_users_of_client', { client: this.selectedClientNameDashboard })
      }
      return ''
    },
    isSelectedClientDashboard () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard !== 0 && this.selectedClientDashboard !== -1
    },
  },
  methods: {
    exportExcel: async function () {
      // Implement the export to Excel functionality here
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    getParamIdClient () {
      const idClient = this.$store.getters['dashboard/getSelectedClient']
      if (this.isSA && idClient !== 0 && idClient !== null) return this.$store.getters['dashboard/getSelectedClient']
      return null
    },
    cleanData () {
      this.dataTable = []
      this.totalData = 0
      this.currentPage = 1
      this.totalPage = 0
      this.ascendingOrder = false
    },
    formatDate: function (strDate) {
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
    getData: async function (data) {
      this.isLoadedData = false
      this.dataTable = []
      try {
        const response = await getConnectedUsers({ page: this.currentPage, perPage: this.perPage, ascendente: this.ascendingOrder, idCliente: this.getParamIdClient() }, data)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          setTimeout(() => {
            this.dataTable = Array.isArray(response.Usuarios) ? response.Usuarios : []
            this.totalData = response.meta?.total ?? this.dataTable.length
            this.currentPage = response.meta?.currentPage ?? this.currentPage
            this.totalPage = response.meta?.total ?? 0
          }, 10)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
    changeCurrentPage (numPage) {
      this.currentPage = numPage
      this.getData()
    },
    changeAscendingOrder (ascending) {
      this.ascendingOrder = ascending
      this.currentPage = 1
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
